class EmployeeDropdownListController {

  constructor(EventEmitter) {
    'ngInject';
    this.EventEmitter = EventEmitter;

  }

  hasEmployees() {
    return this.employees && this.employees.length > 0;
  }

  emitEmployee(employee) {
    this.onSelectEmployee(this.EventEmitter(employee));
  }

}

export default EmployeeDropdownListController;



// WEBPACK FOOTER //
// ./client/app/components/employeeDropdownList/employeeDropdownList.controller.js